export default __webpack_public_path__ + "static/media/baac.2e9c08cc.svg";